module.exports = __webpack_public_path__ + "img/stage1.9583bc36.png";